import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { tenantStatusPresentation } from '@/pages/clients/tenantStatusPresentation';
import type { TenantStatus } from '@/types/tenant';

const STATUSES: readonly TenantStatus[] = ['active', 'paused', 'offboarded'];

export interface TenantStatusRowEditProps {
  website: string;
  status: TenantStatus | string | null;
  /** The current draft value (may equal `status` or the operator's pick). */
  value: TenantStatus | string | null;
  onChange: (next: TenantStatus) => void;
}

/**
 * Row-edit-mode status Select for the /clients roster: a shadcn Select
 * with the three tenant statuses. No confirm, no PATCH — the parent row's
 * Save handler diffs against `status` and writes only changed tenants.
 */
export function TenantStatusRowEdit({ website, status, value, onChange }: TenantStatusRowEditProps) {
  const currentKey = tenantStatusPresentation(value ?? status).key;
  const selectValue = currentKey === 'unknown' ? undefined : currentKey;
  return (
    <Select
      value={selectValue}
      onValueChange={(next) => {
        if (!STATUSES.includes(next as TenantStatus)) return;
        onChange(next as TenantStatus);
      }}
    >
      <SelectTrigger
        className="h-8 w-32"
        aria-label={`Change status for ${website}`}
      >
        <SelectValue placeholder="Pick status" />
      </SelectTrigger>
      <SelectContent>
        {STATUSES.map((v) => (
          <SelectItem key={v} value={v}>
            {v === 'active' ? 'Active' : v === 'paused' ? 'Paused' : 'Offboarded'}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
